import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "HealthCross"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.25 21H9.75C8.92192 20.9992 8.25083 20.3281 8.25 19.5V15.75H4.5C3.67192 15.7492 3.00083 15.0781 3 14.25V9.75C3.00083 8.92192 3.67192 8.25083 4.5 8.25H8.25V4.5C8.25083 3.67192 8.92192 3.00083 9.75 3H14.25C15.0781 3.00083 15.7492 3.67192 15.75 4.5V8.25H19.5C20.3281 8.25083 20.9992 8.92192 21 9.75V14.25C20.9988 15.0779 20.3279 15.7488 19.5 15.75H15.75V19.5C15.7488 20.3279 15.0779 20.9988 14.25 21ZM4.5 9.75V14.25H9.75V19.5H14.25V14.25H19.5V9.75H14.25V4.5H9.75V9.75H4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/HealthCross.vue"]]);
